<template>
  <div
    id="sidebar"
    :class="{ open: screenWidth => 768 || (screenWidth < 768 && isCollapse) }"
  >
    <div v-if="screenWidth < 768" class="menuBars">
      <img
        class="pointer"
        src="@/assets/icons/icon_bars.svg"
        style="width: 25px"
        @click="openSidebar()"
      />
    </div>
    <div class="outer-border" :style="{ width: !isCollapse ? '0px' : '' }">
      <div id="inner-border" class="inner-border">
        <el-menu
          class="el-menu-vertical-demo"
          background-color="transparent"
          :class="{ menuRes: !isCollapse }"
        >
          <el-menu-item
            @mouseover.native="
              clientHover = eventsResolution(clientHover, 'hover')
            "
            @mouseout.native="
              clientHover = eventsResolution(clientHover, 'hover')
            "
            @click="
              goRoute('new-client');
              clearInfo('new-client');
              openSidebar();
            "
            :class="{ active: clientHover }"
          >
            <div class="menu">
              <img
                :src="
                  !clientHover
                    ? require(`@/assets/icons/icon_client.svg`)
                    : require(`@/assets/icons/icon_client_white.svg`)
                "
              />
              <label>NUEVO CLIENTE</label>
            </div>
          </el-menu-item>
          <el-menu-item
            @mouseover.native="shopHover = eventsResolution(shopHover, 'hover')"
            @mouseout.native="shopHover = eventsResolution(shopHover, 'hover')"
            @click="
              openSidebar();
              goRoute('profile');
            "
            :class="{ active: shopHover }"
          >
            <div class="menu">
              <img
                :src="
                  !shopHover
                    ? require(`@/assets/icons/icon_shop.svg`)
                    : require(`@/assets/icons/icon_shop_white.svg`)
                "
              />
              <label>MI PERFIL</label>
            </div>
          </el-menu-item>
          <el-menu-item
            @mouseover.native="
              compareHover = eventsResolution(compareHover, 'hover')
            "
            @mouseout.native="
              compareHover = eventsResolution(compareHover, 'hover')
            "
            @click="
              openSidebar();
              openWindow('https://www.mipodo.com/tarifas-luz/');
            "
            :class="{ active: compareHover }"
          >
            <div class="menu">
              <img
                :src="
                  !compareHover
                    ? require(`@/assets/icons/icon_compare.svg`)
                    : require(`@/assets/icons/icon_compare_white.svg`)
                "
              />
              <label>COMPARAR</label>
            </div>
          </el-menu-item>
          <!-- <el-menu-item
            @mouseover.native="helpHover = eventsResolution(helpHover, 'hover')"
            @mouseout.native="helpHover = eventsResolution(helpHover, 'hover')"
            @click="
              openSidebar();
              goRoute('help');
            "
            :class="{ active: helpHover }"
          >
            <div class="menu">
              <img
                :src="
                  !helpHover
                    ? require(`@/assets/icons/icon_help.svg`)
                    : require(`@/assets/icons/icon_help_white.svg`)
                "
              />
              <label>AYUDA</label>
            </div>
          </el-menu-item> -->
          <el-menu-item
            @mouseover.native="userHover = eventsResolution(userHover, 'hover')"
            @mouseout.native="userHover = eventsResolution(userHover, 'hover')"
            @click="
              openSidebar();
              goRoute('user');
            "
            :class="{ active: userHover }"
            v-if="userLogged.role === 'ROLE_ADMIN'"
          >
            <div class="menu">
              <img
                :src="
                  !userHover
                    ? require(`@/assets/icons/icon_user.svg`)
                    : require(`@/assets/icons/icon_user_white.svg`)
                "
              />
              <label>USUARIOS</label>
            </div>
          </el-menu-item>
          <el-menu-item
            @mouseover.native="filesHover = eventsResolution(filesHover, 'hover')"
            @mouseout.native="filesHover = eventsResolution(filesHover, 'hover')"
            @click="
              openSidebar();
              goRoute('contracts');
            "
            :class="{ active: filesHover }"
          >
            <div class="menu">
              <img
                :src="
                  !filesHover
                    ? require(`@/assets/icons/icon_compare.svg`)
                    : require(`@/assets/icons/icon_compare_white.svg`)
                "
              />
              <label>CONTRATOS</label>
            </div>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EventBus from "@/plugins/EventBus";

import AuthService from "@/services/auth.service";

export default {
  name: "sidebar",
  data() {
    return {
      showMenu: false,
      shopHover: false,
      userHover: false,
      helpHover: false,
      clientHover: false,
      compareHover: false,
      filesHover: false,
      screenWidth: null,
      isCollapse: true
    };
  },
  computed: {
    ...mapState({
      userLogged: "user"
    })
  },
  mounted() {
    document
      .getElementById("app")
      .addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    handleScroll() {
      document.querySelector(
        "#inner-border"
      ).scrollTop = document.querySelector("#app").scrollTop;
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth < 768) {
        this.isCollapse = false;
        this.$emit("open", false);
      } else {
        this.isCollapse = true;
        this.$emit("open", true);
      }
    },
    eventsResolution(obj, event) {
      if (this.screenWidth < 768 && event === "click") {
        return !obj;
      } else if (this.screenWidth >= 768 && event === "hover") {
        return !obj;
      }

      return obj;
    },
    goRoute(route) {
      AuthService.sessionExpired();
      if (route !== this.$route.name) {
        this.$router.push({ name: route });
      }
    },
    openWindow(url) {
      window.open(url, "_blank");
    },
    clearInfo(route) {
      if (route === this.$route.name) {
        setTimeout(() => {
          EventBus.$emit("clear");
        }, 0);
      }
    },
    openSidebar() {
      if (this.screenWidth < 768) {
        this.isCollapse = !this.isCollapse;
        this.$emit("open", this.isCollapse);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/styles.scss";
#sidebar {
  width: auto;
  min-height: 100vh;
  height: 100vh;
  position: fixed;
  z-index: 10;
  .outer-border {
    width: 126px;
    position: relative;
    overflow: hidden;
    transition: 0.6s;
    height: 100vh;
    background: $white-color !important;
    border-image-source: $gradient-bottom-color;
    border-image-slice: 1;
    border-left: 5px solid;
    border-right: 0px !important;
    min-height: 100vh;
    height: 100vh;
    transition: 0.6s;
    padding-top: 100px;
    text-align: center;
  }
  .inner-border {
    position: absolute;
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  ul {
    width: 126px;
    height: calc(100vh - 100px);
    li.el-menu-item {
      height: 118px;
      border-top: 5px solid $grey-white-color;
      background-color: transparent !important;
      display: inline-flex;
      padding-right: 0px !important;
      overflow: hidden;
      transition: 0.6s;
      width: 100%;
      justify-content: center;
      padding-left: 0 !important;
      &:last-child {
        border-bottom: 5px solid $grey-white-color;
      }
      .menu {
        padding: 10px 0px !important;
        transition: 0.6s;
        label {
          display: block;
          font-size: 15px;
          cursor: pointer;
        }
        img {
          width: 60px;
        }
      }
    }
    li.el-menu-item.active {
      background: $gradient-right-color;
      border-left: 1px solid $white-color;
      label {
        color: $white-color;
        cursor: pointer;
      }
    }
  }
  &:hover {
    width: auto;
  }
  &.open {
    width: auto;
    ul {
      li.el-menu-item {
        background-color: transparent !important;
      }
      li.el-menu-item.active {
        background: $gradient-right-color !important;
        border-left: 1px solid $white-color;
        label {
          color: $white-color;
          cursor: pointer;
        }
      }
    }
  }
  .menuBars {
    width: 45px;
    padding: 8px;
    position: absolute;
    z-index: 10;
  }
  .menuRes {
    width: 0px;
    border: 0px;
    li.el-menu-item {
      .menu {
        width: 0;
      }
      .submenu {
        margin: 0;
      }
    }
  }
}

@media (max-width: 768px) {
  #sidebar {
    width: auto;
    .outer-border {
      width: 80px;
    }
    ul {
      width: 80px;
      li.el-menu-item {
        height: 90px;
        padding: 0 !important;
        .menu {
          width: 75px;
          padding: 0px !important;
          label {
            font-size: 9px;
            line-height: 9px;
          }
          img {
            width: 40px;
          }
        }
      }
    }
    &.open {
      width: auto;
    }
    &:hover {
      width: auto;
    }
  }
}
</style>
